package com.ijoin.platform

import kotlinx.browser.window

/**
 * JS implementation of share handler
 */
actual object ShareHandler {
    actual fun shareUrl(url: String, title: String?) {
        // Try Web Share API first (mobile browsers)
        val navigator = window.navigator.asDynamic()
        if (navigator.share != undefined) {
            val shareData = js("{}")
            shareData.url = url
            if (title != null) {
                shareData.title = title
            }
            navigator.share(shareData)
        } else {
            // Fallback: copy to clipboard
            window.navigator.clipboard.writeText(url)
        }
    }
}